<template>
  <div :class="['field', { 'has-error': error }]">
    <label
      v-if="label"
      class="field-label"
      :for="id"
    >
      {{ label }}
      {{ required ? '*' : '' }}
    </label>

    <p
      v-if="description"
      class="field-description"
    >
      {{ description }}
    </p>

    <input
      :id="id"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="onInput"
      class="field-input"
    >

    <span
      v-if="error"
      class="field-error"
    >
      {{ error }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    description: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    error: {
      type: String
    }
  },
  methods: {
    onInput(e) {
      const { currentTarget } = e;
      const { value } = currentTarget;

      this.$emit('input', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.field {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &.has-error {
    input {
      border-color: $primary;
      color: $primary;
    }
  }

  &-label {
    @include padding(null null 9px);
    @include font('primary', 'bold');
    font-size: rem(18px);
    line-height: 1;
  }

  &-description {
    @include padding(null null 24px);
    color: rgba($black, .5);
    font-size: rem(12px);
    line-height: (14 / 12);
  }

  &-input {
    @include padding(16px);
    @include font('primary', 'regular');
    display: block;
    width: 100%;
    transition: border-color .3s $ease-out-quart;
    border: 1px solid $black-lighter;
    border-radius: 5px;
    background-color: $black-lighter;
    appearance: none;
    color: $white;
    font-size: rem(16px);
    line-height: 1;
    outline: none;

    &:focus {
      border-color: rgba($white, .5);
    }

    &::placeholder {
      color: rgba($white, .5);
    }
  }

  &-error {
    @include padding(12px null null);
    color: $primary;
    font-size: rem(12px);
    line-height: 1;
  }
}
</style>
